<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'政策指引管理'},{name:'政策申报列表',goback:true},{name:'政策申报明细'}]" :title="'政策申报明细'" ref="breadcrumb"/>
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="政策申报详情" name="1"></el-tab-pane>
              <el-tab-pane label="申请记录" name="2"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" v-show="tab==='2'" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">受理状态</span>
                        <el-select  v-model="sendInfoOne.rate" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 主体 -->
            <!-- 产品详情 -->
            <div class="box detailBas" v-show="tab==='1'">
                <el-card class="basic box_card" header="" shadow="never">
                  <div class="basisTitle">基础信息：</div>
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">政策申报标题：</div>
                        <div class="content">{{detailInfo.policyName}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="child">
                          <div class="name">适用行业：</div>
                          <div class="content">{{detailInfo.classifyValue}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">适用地区：</div>
                        <div class="content">{{detailInfo.provinceValue+detailInfo.cityValue+detailInfo.areaValue}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="child">
                            <div class="name">来源：</div>
                            <div class="content">{{detailInfo.source}}</div>
                        </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="child">
                          <div class="name">政策详情：</div>
                          <div class="content super_p" v-html="detailInfo.policyDetails"></div>
                      </div>
                    </el-col>
                    </el-row>
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">申报流程：</div>
                        <ul>
                            <li v-for="(item,i) in detailInfo.declareProcess" :key="i">
                                    {{(i+1)+'.'+item.content}}
                            </li>
                        </ul>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">附件：</div>
                        <ul class="content">
                            <li v-for="(item,i) in detailInfo.fileList" :key="i">
                                <span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i>
                            </li>
                        </ul>
                    </div>
                    </el-col>
                  </el-row>
                </el-card>
                <el-card class="basic box_card" header="" shadow="never">
                  <div class="basisTitle">其它信息：</div>
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">发布账号：</div>
                        <div class="content">{{detailInfo.createUserName}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">发布时间：</div>
                        <div class="content">{{detailInfo.createTime}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8"></el-col>
                    <el-col :span="8"></el-col>
                  </el-row>
                </el-card>
            </div>
            <!-- 客户申请表格 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    width="200"
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="rate"
                    show-overflow-tooltip
                    sortable="custom"
                    width="150"
                    label="受理状态">
                    <template slot-scope="{row}">
                      {{row.rateValue}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" v-show="tab==='2'" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                custom-class="super_dialog"
                width="50%">
                <div class="basic boxChild">
                    <div class="tit">提交信息</div>
                    <div class="child">
                        <div class="name">申请人姓名：</div>
                        <div class="content">{{detailInfoDia.applicant}}</div>
                    </div>
                    <div class="child">
                        <div class="name">联系手机号：</div>
                        <div class="content">{{detailInfoDia.contactPhone}}</div>
                    </div>
                    <div class="child">
                        <div class="name">公司全称：</div>
                        <div class="content">{{detailInfoDia.applyCompany}}</div>
                    </div>
                    <div class="child">
                        <div class="name">说明：</div>
                        <div class="content">{{detailInfoDia.applyRemark}}</div>
                    </div>
                    <div class="attachment">
                        <div class="name">附件：</div>
                        <ul class="content">
                            <li v-for="(item,i) in detailInfoDia.fileList" :key="i">
                                <span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i>
                            </li>
                        </ul>
                    </div>
                    <div class="child">
                        <div class="name">提交时间：</div>
                        <div class="content">{{detailInfoDia.createTime}}</div>
                    </div>
                    <div class="tit mts">受理信息</div>
                    <div class="child">
                        <div class="name">受理状态：</div>
                        <div class="content">{{detailInfoDia.rateValue}}</div>
                    </div>
                    <div class="child">
                        <div class="name">说明：</div>
                        <div class="content">{{detailInfoDia.dealWithRemark}}</div>
                    </div>
                    <div class="child">
                        <div class="name">更新时间：</div>
                        <div class="content">{{detailInfoDia.updateTime}}</div>
                    </div>
                </div>
            </el-dialog>
        </div>
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    mixins:[timeMixins],
    components:{
        breadcrumb
    },
    data(){
        return{
          loading: void 0,
            bHeight: void 0,
            id:'',//详情id
            tab:'1',//选项卡
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '申请人姓名'
            }, {
                value: '4',
                label: '联系手机号'
            }],//检索下拉
            detailInfoDia:{
                
            },
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                id:"",//申请id
                loanId:"",
                userName:'',//账号
                applicant:'',//申请人姓名
                contactPhone:"",//联系手机号
                property:null,//排序字段
                direction:null,//排序方式
                rate:null,//受理结果
            },//检索提交数据
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            detailInfo:{
                policyName:"",
                industry:'',
                areaValue:"",
                source:"",
                policyDetails:"",
                declareProcess:[],
                fileList:[],
                createUserName:'',
                createTime:''
            },
            totalSize:null,
            statusList:[],
        }
    },
    methods:{
      onReset(){
        const that = this
            that.getSelect='';//检索下拉的值
            that.getValue='';//检索输入框的值
            that.dateS=[];//日期
            that.sendInfoOne.currentPage=1;//当前页
            that.sendInfoOne.pageSize=20;//页条数
            that.sendInfoOne.checkStatus='';//审核结果
            that.sendInfoOne.endDate='';//结束时间
            that.sendInfoOne.startDate='';//开始时间
            that.sendInfoOne.id="";//申请id
            that.sendInfoOne.userName='';//账号
            that.sendInfoOne.applicant='';//姓名
            that.sendInfoOne.contactPhone='';//政策申请标题
            that.sendInfoOne.property = null
            that.sendInfoOne.direction = null
            that.totalSize=null;//总页码
            that.getData()
      },
      //下载附件
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        // 切换选项啦
        changeTab:function(tab){
            const that= this
            that.tab=tab.name;
            that.onReset()
            if(that.tab === '2'){
              
              setTimeout(() => {
                  let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
              }, 100);
              
            }
        },
        //检索事件
        retrieval:function(){},
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='ASC';
            }else{
                order='DESC';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData()
        },
        //查看明细
        check:function(row){
            this.$axiosc.get('backstage/policy/declare/apply/details/'+row.id).then(res=>{
                if(res.code == 200){
                    this.detailInfoDia = res.data
                    this.dialogInfo=true;
                }else{

                }
            })
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        getData(){
            
            if(this.tab === '1' || this.tab === 1){
              this.loading = true
                this.$axiosc.get('backstage/policy/declare/details/'+this.id).then(res=>{
                    if(res.code == 200){
                        this.detailInfo = res.data
                        this.loading = false
                    }else{
                        this.$alert(res.msg)
                        this.loading = false
                    }
                }).catch(e=>{
                  this.loading = false
                })
            }else{
                if(this.dateS&&this.dateS.length>0){
                    this.sendInfoOne.startDate=this.dateS[0];
                    this.sendInfoOne.endDate=this.dateS[1];
                }else{
                    this.sendInfoOne.startDate=null;
                    this.sendInfoOne.endDate=null;
                }
                this.sendInfoOne.id="";//申请id
                this.sendInfoOne.userName='';//账号
                this.sendInfoOne.applicant='';//姓名
                this.sendInfoOne.contactPhone='';//政策申请标题
                if(this.getSelect=='1'){ //申请id
                    this.sendInfoOne.id=this.getValue;
                }else if(this.getSelect=='2'){ //账号
                    this.sendInfoOne.userName=this.getValue;
                }else if(this.getSelect=='3'){ //姓名
                    this.sendInfoOne.applicant=this.getValue;
                }else if(this.getSelect=='4'){ //联系手机号
                    this.sendInfoOne.contactPhone=this.getValue;
                }
                this.loading = true
                this.$axiosc.get('backstage/policy/declare/apply/list',{params:this.sendInfoOne}).then(res=>{
                    if(res.code==200){
                        this.tableData=res.data.content;
                        this.totalSize=res.data.totalElements;
                        this.loading = false
                    }else{
                        this.$alert(res.msg)
                        this.loading = false
                    }
                }).catch(e=>{
                  this.loading = false
                })
            }
        }
    },
    created(){
        this.$axiosz.get('backstage/sysDict/ACCEPTANCE_STATUS').then((r)=>{ //受理状态
            if(r.code==200){
                this.statusList=r.data;
            }
        })
        if(this.$route.query.id){
            this.id=this.$route.query.id;
            this.sendInfoOne.loanId = this.id
            this.getData()
        }
        
    },
    mounted(){
      const that = this
      let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25 + (that.$refs.breadcrumb?that.$refs.breadcrumb.$el.offsetHeight:0)
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90+25 + (that.$refs.breadcrumb?that.$refs.breadcrumb.$el.offsetHeight:0)
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:calc(100% - 20px);
    padding:10px 20px;
    overflow: hidden;
    .detailBas{
        margin-top: 10px;
        overflow-x:hidden;
        overflow-y: auto;
        height:calc(100% - 110px);
    }
}
.tit{
    font-weight: 600;
    color: #000;
}
.mts{
    margin-top: 20px;
}
.box{
    height:94%;
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
    .tableChild{
      margin-top:8px !important;
    }
    .child,.attachment{
      margin-top:8px;
    }
}
.boxChild{
  .child,.basisTitle,.attachment,.tit{
      margin-bottom:10px;
    }
}
.super_dialog{
  .child{
    .name{
      width:80px;
      text-align: right;
    }
  }
}
</style>